import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ImageModalComponent } from './image-modal/image-modal.component';
import { VideoModalComponent } from './video-modal/video-modal.component';
import { AudioModalComponent } from './audio-modal/audio-modal.component';

@Injectable({ providedIn: 'root' })
export class FilePreviewService {
  constructor(private modalService: NgbModal) { }

  open(file: any, url: string): void {
    if (this.isImage(file)) {
      this.openImage(file, url);
    } else if (this.isVideo(file)) {
      this.openVideo(file, url);
    } else if (this.isAudio(file)) {
      this.openAudio(file);
    } else {
      window.open(url, '_blank');
    }
  }

  openImage(file: any, url: string, options: NgbModalOptions = {}): void {
    if (!this.isImage(file)) return;

    const modalRef = this.modalService.open(ImageModalComponent, {
      ...options,
      windowClass: 'gf-image-preview-modal'
    });
    modalRef.componentInstance.file = file;
    modalRef.componentInstance.url = url;
    modalRef.componentInstance.close = () => modalRef.close();
  }

  isImage(file: any): boolean {
    const type = (file?.fileType || '').toLowerCase();
    const name = (file?.fileName || '').toLowerCase();
    return type.startsWith('image/') || /\.(gif|jpg|jpeg|png|webp|avif|tiff|bmp|svg)$/.test(name);
  }

  private isVideo(file: any): boolean {
    const type = (file?.fileType || '').toLowerCase();
    const name = (file?.fileName || '').toLowerCase();
    return type.startsWith('video/') || /\.(mp4|webm|ogg|mov|avi|m4v|mpeg)$/.test(name);
  }

  private isAudio(file: any): boolean {
    const type = (file?.fileType || '').toLowerCase();
    const name = (file?.fileName || '').toLowerCase();
    return type.startsWith('audio/') || /\.(mp3|wav|m4a|aac|flac|opus|weba)$/.test(name);
  }

  private openVideo(file: any, url: string): void {
    const modalRef = this.modalService.open(VideoModalComponent, {size: 'lg'});
    modalRef.componentInstance.file = file;
    modalRef.componentInstance.url = url;
    modalRef.componentInstance.close = () => modalRef.close();
  }

  private openAudio(file: any): void {
    const modalRef = this.modalService.open(AudioModalComponent);
    modalRef.componentInstance.file = file;
    modalRef.componentInstance.close = () => modalRef.close();
  }
}